export const notificationsTypes = {
  MARK_AS_READED: 'MARK_AS_READED',
  UPDATE_IS_ALL_NOTIFICATION_READED: 'UPDATE_IS_ALL_NOTIFICATION_READED',
};
